import { Center, Icon } from '@chakra-ui/react';
import { ChevronLeft, ChevronRight, X } from '@kula-ai/icons-core';

interface ViewScorecardNavButtonsProps {
  onClose: () => void;
  onPrev: () => void;
  onNext: () => void;
  isFirstScorecard: boolean;
  isLastScorecard: boolean;
}

export const ViewScorecardNavButtons = ({
  onClose,
  onPrev,
  onNext,
  isFirstScorecard,
  isLastScorecard,
}: ViewScorecardNavButtonsProps) => {
  return (
    <>
      {/* Close button */}
      <Center
        w="48px"
        h="48px"
        left="-70px"
        top="32px"
        pos="absolute"
        bg="#fff"
        borderRadius="full"
        onClick={onClose}
        cursor="pointer"
        boxShadow="md"
        data-test-id="scorecard-drawer-close-icon"
      >
        <Icon as={X} w="20px" h="20px" />
      </Center>

      {/* Next button */}
      <Center
        w="48px"
        h="48px"
        left="-70px"
        top="86px"
        pos="absolute"
        borderRadius="full"
        bg="#fff"
        cursor={isLastScorecard ? 'not-allowed' : 'pointer'}
        onClick={!isLastScorecard ? onNext : undefined}
        opacity={isLastScorecard ? 0.5 : 1}
        boxShadow="md"
        data-test-id="next-scorecard-icon"
      >
        <Icon as={ChevronRight} w="24px" h="24px" />
      </Center>

      {/* Previous button */}
      <Center
        w="48px"
        h="48px"
        left="-70px"
        top="140px"
        pos="absolute"
        borderRadius="full"
        bg="#fff"
        cursor={isFirstScorecard ? 'not-allowed' : 'pointer'}
        onClick={!isFirstScorecard ? onPrev : undefined}
        opacity={isFirstScorecard ? 0.5 : 1}
        boxShadow="md"
        data-test-id="previous-scorecard-icon"
      >
        <Icon as={ChevronLeft} w="24px" h="24px" />
      </Center>
    </>
  );
};
